import { makeAutoObservable, runInAction } from 'mobx';
import { ICategoryGalleryBlockImage, ICategoryGalleryBlockTag } from '@features/cms/typescript';
import CategoryGalleryFilterState from '@features/cms/components/categories/CategoryGalleryBlock/mobx/state/CategoryGalleryFilterState';
import CategoryGalleryFiltrationState from '@features/cms/components/categories/CategoryGalleryBlock/mobx/state/CategoryGalleryFiltrationState';
class CategoryGalleryStore {
  public isAsideOpen = false;
  public asideAttributeOpen = '';
  private initImages: ICategoryGalleryBlockImage[] = [];
  private filteredImages: ICategoryGalleryBlockImage[] = [];
  private lastImageIndex = 0;
  private imageRows: ICategoryGalleryBlockImage[][] = [];
  private availableFilters: CategoryGalleryFiltrationState | null = null;
  private selectedFilters: CategoryGalleryFiltrationState | null = null;
  constructor(images: ICategoryGalleryBlockImage[], availableTags: Record<string, ICategoryGalleryBlockTag>) {
    makeAutoObservable(this);
    runInAction(() => {
      this.initImages = images;
      this.filteredImages = images;
      this.lastImageIndex = 0;
      const availableFiltersAttributes = Object.values(availableTags).map(tag => new CategoryGalleryFilterState(tag));
      this.availableFilters = new CategoryGalleryFiltrationState(availableFiltersAttributes);
      const selectedFiltersAttributes = Object.values(availableTags).map(tag => new CategoryGalleryFilterState(tag));
      const selectedFilters = new CategoryGalleryFiltrationState(selectedFiltersAttributes);
      selectedFilters.deselectAllValues();
      this.selectedFilters = selectedFilters;
      this.filterImages();
    });
  }
  get images() {
    return this.imageRows;
  }
  get currentCount() {
    return this.lastImageIndex;
  }
  get allImagesCount() {
    return this.filteredImages.length;
  }
  getImagesCountWithFilter = (filterState: CategoryGalleryFiltrationState) => {
    const filters = filterState.attributes || [];
    const filteredImages = this.initImages.filter(image => {
      if (filters.length === 0 || filters.every(filter => filter.values.length === 0)) {
        return true;
      }
      const filtersValues = filters.map(filter => filter.values.map(value => value.code)).flat();
      const imageTagsValues = Object.values(image.tags).map(tag => tag).flat();
      let isImageMatched = false;
      filtersValues.forEach(filterValue => {
        if (imageTagsValues.includes(filterValue)) {
          isImageMatched = true;
        }
      });
      return isImageMatched;
    });
    return filteredImages.length;
  };
  openAside = (attributeCode: string) => {
    if (this.availableFilters && this.availableFilters.doesAttributeExist(attributeCode)) {
      this.asideAttributeOpen = attributeCode;
    }
    this.isAsideOpen = true;
  };
  closeAside = () => {
    this.isAsideOpen = false;
    this.asideAttributeOpen = '';
  };
  backToMainAside = () => {
    this.asideAttributeOpen = '';
  };
  goAsideToFilter = (attributeCode: string) => {
    if (this.availableFilters && this.availableFilters.doesAttributeExist(attributeCode)) {
      this.asideAttributeOpen = attributeCode;
    }
  };
  loadRow = () => {
    let currentImageIndex = this.lastImageIndex;
    const nextImage = this.filteredImages[currentImageIndex];
    const nextRow: ICategoryGalleryBlockImage[] = [];
    if (nextImage) {
      const {
        orientation
      } = nextImage;
      if (orientation === 'horizontal') {
        nextRow.push(nextImage);
        currentImageIndex += 1;
        const nextImage2 = this.filteredImages[currentImageIndex];
        if (nextImage2) {
          nextRow.push(nextImage2);
          currentImageIndex += 1;
        }
      }
      if (orientation === 'vertical') {
        nextRow.push(nextImage);
        currentImageIndex += 1;
        const nextImage2 = this.filteredImages[currentImageIndex];
        if (nextImage2) {
          const {
            orientation: orientation2
          } = nextImage2;
          if (orientation2 === 'vertical') {
            nextRow.push(nextImage2);
            currentImageIndex += 1;
            const nextImage3 = this.filteredImages[currentImageIndex];
            if (nextImage3) {
              nextRow.push(nextImage3);
              currentImageIndex += 1;
            }
          }
          if (orientation2 === 'horizontal') {
            nextRow.push(nextImage2);
            currentImageIndex += 1;
          }
        }
      }
    }
    runInAction(() => {
      this.lastImageIndex = currentImageIndex;
      this.imageRows = [...this.imageRows, nextRow];
    });
  };
  setSelectedFiltersState = (attributes: CategoryGalleryFilterState[]) => {
    this.selectedFilters = new CategoryGalleryFiltrationState([...attributes]);
    this.filterImages();
  };
  get selectedFiltersState() {
    return this.selectedFilters;
  }
  get availableFiltersState() {
    return this.availableFilters;
  }
  filterImages = () => {
    const filters = this.selectedFilters?.attributes || [];
    const filteredImages = this.initImages.filter(image => {
      if (filters.length === 0 || filters.every(filter => filter.values.length === 0)) {
        return true;
      }
      const filtersValues = filters.map(filter => filter.values.map(value => value.code)).flat();
      const imageTagsValues = Object.values(image.tags).map(tag => tag).flat();
      let isImageMatched = false;
      filtersValues.forEach(filterValue => {
        if (imageTagsValues.includes(filterValue)) {
          isImageMatched = true;
        }
      });
      return isImageMatched;
    });
    this.filteredImages = filteredImages;
    this.imageRows = [];
    this.lastImageIndex = 0;
    this.loadRow();
    this.loadRow();
  };
}
export default CategoryGalleryStore;